import React from 'react';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useState, useEffect} from 'react';
import {HOST} from './config';

function ReviewFile(props) { 
  const [type, setType] = useState(props.info.type || 'other')
  const [filename, setFilename] = useState(props.info.filename)
  const [changed, setChanged]  = useState(false)
  const [didInitialLoad, setDidIntialLoad]  = useState(false)
  
  useEffect( () => {
    setDidIntialLoad(true)
  }, [])
  
  useEffect((prev)=> {
    if (!didInitialLoad)
      return
    setChanged(true)
  }, [type, filename])
  
  useEffect((prev)=> {
    if (props.info.type)
      setType(props.info.type)
  }, [props.info.type])
  
  useEffect((prev)=> {
    setFilename(props.info.filename)
  }, [props.info.filename])
  
  const handleFileUpdate = () => {
      try {
        fetch(HOST + '/api/files/' + props.info.id + "/?caseId",
        {   
          "method": "PATCH",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
          "body": JSON.stringify({ "filename": filename, "type": type })
         })
        .then((res) => res.json())
        .then((json) => {
          setChanged(false)
        })
      } catch (err) {
        console.log(err);
      } finally {
      }
  };

  return (<>
    <div className="main-form">
      <FormControl >
        <Grid sx={{ p: 2}} container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Filename"
              name="filename"
              value={filename}
              onChange={(e) => setFilename(e.target.value)}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
              <FormControl variant="outlined" fullWidth sx={{  }}>
              <InputLabel id="type-label">Type *</InputLabel>
            <Select
              name="type"
              value={type}
              onChange={(e) => setType(e.target.value)}
              labelId='type-label'
              fullWidth
              required >
                <MenuItem value={'repair_order'}>Repair Order</MenuItem>
                <MenuItem value={'purchase_contract'}>Purchase Contract</MenuItem>
                <MenuItem value={'lease_agreement'}>Lease Agreement</MenuItem>
                <MenuItem value={'warranty_info'}>Warranty Info</MenuItem>
                <MenuItem value={'retainer'}>Retainer</MenuItem>
                <MenuItem value={'other'}>Other</MenuItem>
            </Select>
            </FormControl>
          </Grid>
          {changed &&
            <Grid item xs={12}>
              <Button onClick={() => handleFileUpdate() } variant="contained" type="submit" className="submit-btn">
                Update 
              </Button>
            </Grid>
          }
        </Grid>
      </FormControl>
    </div>
    
  </>)
}
export default ReviewFile;
